<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="root-body-inner">
        <div class="pml-header">
            <div class="pml-header-title">{{group.Name}}</div>
        </div>
        <div class="flex-row">
            <!-- Left block -->
            <div class="filler">
                <div class="field" style="margin-top: 20px;">
                    <div>Name</div>
                    <input pInputText [(ngModel)]="group.Name" [disabled]="true" />
                </div>
                <div class="field" style="margin-top: 20px;">
                    <div>Description</div>
                    <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="group.Description" [disabled]="true"></textarea>
                </div>
            </div>
            <!-- Right block -->
            <div class="filler">
                <div class="flex-row">
                    <div class="filler"></div>
                    <div style="margin-top: 20px;">
                        <button pButton type="button" label="Edit"
                                (click)="onEditClick()"></button>
                    </div>
                </div>
                <div class="field" style="margin-top: 46px; padding-left: 20px;">
                    <div>Geo Zone/Polygon</div>
                    <div id="groupDetailsMap" style="height: 520px;"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<partner-mart-locations-edit-group *ngIf="isEditGroupPopupVisible"
                                     [groupId]="groupId"
                                     [onSave]="onEditGroupPopupSave"
                                     [onHide]="onEditGroupPopupHide"></partner-mart-locations-edit-group>

<p-toast position="top-right"></p-toast>
